import { i18n } from '#react/i18n/create'
import { params } from '@nanostores/i18n'

export const dialogMessageDefaults = {
  cancel: 'Cancel',
  apply: 'Apply',
  close: 'Close',
  rename: 'Rename',
  renameLayers: params('Rename {count} layers'),
  renamePreview: 'Preview',
  renameMatch: 'Match',
  renameTo: 'Rename to',
  renameCurrentName: 'Current name',
  renameNumberAscending: 'Number ↑',
  renameNumberDescending: 'Number ↓',
  renameStartAscendingFrom: 'Start ascending from',
  renameStopDescendingAt: 'Stop descending at',
  renameInvalidPattern: 'Invalid regular expression',
  ok: 'OK',
  copy: 'Copy',
  copied: 'Copied',
  copiedExclamation: 'Copied!',
  copyMessage: 'Copy message',
  createCollection: 'Create collection',
  renameCollection: 'Rename collection',
  deleteCollection: 'Delete collection',
  localVariables: 'Local variables',
  localStyles: 'Local styles',
  noVariableCollections: 'No variable collections',
  modes: 'Modes',
  addMode: 'Add mode',
  renameMode: 'Rename mode',
  duplicateMode: 'Duplicate mode',
  deleteMode: 'Delete mode',
  setDefaultMode: 'Set as default',
  codeSource: 'Code source',
  codeSourceDesignJSX: 'Design JSX',
  codeSourceTailwindJSX: 'Tailwind JSX',
  codeSourceHTMLCSS: 'HTML/CSS',
  codeEditorDesignLabel: 'Design JSX',
  codeEditorHTMLCSSLabel: 'HTML and CSS',
  codeUpdating: 'Updating…',
  codeUpdatedLive: 'Updated live',
  codePreviewFailed: 'Preview failed',
  codeGeneratedReadOnly: 'Generated, read only',
  codeReset: 'Reset',
  copyJSXReference: 'Copy JSX prop reference to clipboard',
  jsxUpToDate: 'Up to date',
  importLabel: 'Import',
  importHTMLCSS: 'Import HTML/CSS',
  importHTMLCSSDescription: 'Paste HTML plus optional CSS or compiled Tailwind CSS.',
  paste: 'Paste',
  importFailed: 'Import failed. Check the HTML and CSS, then try again.',
  importReplacesDocument: 'Import replaces the current document.',
  importing: 'Importing…',
  importToCanvas: 'Import to canvas',
  newTab: 'New tab',
  closeTab: params('Close {name}'),
  recoverUnsavedWork: 'Recover unsaved work',
  recoverUnsavedWorkDescription: 'OpenPencil found documents from a previous session.',
  unsavedLocalDraftPrompt: params(
    '“{name}” has newer unsaved changes on this device. Restore them?'
  ),
  restore: 'Restore',
  discard: 'Discard',
  recoveryFailed: 'Could not restore this document.',
  settingsRecovery: 'Recovery',
  settingsRecoveryDescription: 'Control local crash-recovery copies for unsaved documents.',
  preserveUnsavedWork: 'Automatically preserve unsaved work',
  preserveUnsavedWorkDescription:
    'Store local recovery copies so documents can be restored after an unexpected shutdown.',
  showUI: params('Show UI ({shortcut})'),
  fontSettings: 'Font settings',
  fontIssueFound: '1 font face is unavailable or substituted',
  fontIssuesFound: params('{count} font faces are unavailable or substituted'),
  selectAffectedLayers: 'Select layers',
  retryFonts: 'Retry fonts',
  retryingFonts: 'Retrying…',
  expandFontIssues: 'Show font issues',
  collapseFontIssues: 'Hide font issues',
  noFontSubstitute: 'no substitute available',
  affectedLayer: '1 affected layer',
  affectedLayerCount: params('{count} affected layers'),
  fontSettingsDesktopDescription:
    'Access system fonts, online providers, fallback packs, and cached downloads.',
  fontSettingsBrowserDescription:
    'Allow browser access to local fonts and manage online font providers.',
  fontSettingsLocalDescription:
    'Allow browser access to local and bundled fonts. Online font providers are not used in this editor.',
  localFonts: 'Local fonts',
  onlineFonts: 'Online fonts',
  downloadedCache: 'Downloaded cache',
  lastUpdated: 'Last updated',
  enabled: 'Enabled',
  disabled: 'Disabled',
  denied: 'Denied',
  unavailable: 'Unavailable',
  notRequested: 'Not requested',
  never: 'Never',
  systemFontAccess: 'System font access',
  systemFontsAvailable: 'System fonts are available.',
  allowBrowserFontAccess: 'Allow browser font access when system fonts are missing.',
  allow: 'Allow',
  requesting: 'Requesting…',
  onlineFontProviders: 'Online font providers',
  downloadMissingWebFonts: 'Download missing web fonts through enabled providers.',
  webFontProvidersRequireDesktopApp:
    'Online font provider catalogs are unavailable in the web app. Download the desktop app to browse and load provider fonts.',
  clipboardImageUnavailableWeb:
    'Pasted design includes 1 image that cannot be loaded in the web app. Use the desktop app to include it.',
  clipboardImagesUnavailableWeb: params(
    'Pasted design includes {count} images that cannot be loaded in the web app. Use the desktop app to include them.'
  ),
  clipboardImageFetchFailed:
    'Failed to fetch 1 image from Figma. Check that the source file is accessible and try again.',
  clipboardImagesFetchFailed: params(
    'Failed to fetch {count} images from Figma. Check that the source file is accessible and try again.'
  ),
  enable: 'Enable',
  disable: 'Disable',
  fallbackPacks: 'Fallback packs',
  downloadFallbackPacksDescription:
    'Download CJK and Arabic fallbacks before opening files that need them.',
  download: 'Download',
  downloading: 'Downloading…',
  refresh: 'Refresh',
  clearCache: 'Clear cache',
  localFontAccessEnabled: 'Local font access enabled.',
  localFontAccessNotGranted: 'Local font access was not granted.',
  onlineFontProvidersEnabled: 'Online font providers enabled.',
  onlineFontProvidersDisabled: 'Online font providers disabled.',
  fontProviderEnabled: params('Enabled {provider}.'),
  fontProviderDisabled: params('Disabled {provider}.'),
  fallbackFontsDownloaded: 'Fallback fonts downloaded.',
  fallbackFontsDownloadFailed: 'Could not download fallback fonts.',
  downloadedFontCacheCleared: 'Downloaded font cache cleared.',
  downloadedFontCacheClearFailed: 'Could not clear downloaded font cache.',
  you: 'You',
  youSuffix: 'you',
  inThisRoom: 'In this room',
  disconnect: 'Disconnect',
  followingPeerStop: params('Following {name} (click to stop)'),
  clickToFollowPeer: params('Click to follow {name}'),
  connectAIProvider: 'Connect an AI provider to start chatting.',
  connect: 'Connect',
  testConnection: 'Test connection',
  testingConnection: 'Testing…',
  connectionTestSuccess: 'Connected successfully. Model is reachable.',
  connectionTestMissingAPIKey: 'Enter an API key before testing.',
  connectionTestMissingBaseURL: 'Enter a base URL before testing.',
  connectionTestMissingModel: 'Enter a model ID before testing.',
  connectionTestInvalidBaseURL:
    'Base URL is invalid. Use a full URL like https://api.example.com/v1.',
  connectionTestAuthFailed: 'Authentication failed. Check your API key.',
  connectionTestInsufficientCredit:
    'The provider account has insufficient credit or quota. Top it up and try again.',
  connectionTestModelNotFound: 'Model not found. Check the model ID.',
  connectionTestAPITypeMismatch:
    'This endpoint does not appear to support the selected API type. Try Completions or Responses.',
  connectionTestBrowserNetworkFailed:
    'Could not reach this endpoint from the browser. Try the desktop app or use an endpoint with CORS enabled.',
  connectionTestNetworkFailed:
    'Could not reach the endpoint. Check the URL and your network connection.',
  connectionTestUnknownFailed: 'Connection test failed. Check the provider settings and try again.',
  getAPIKey: params('Get an {provider} API key →'),
  oneKeyManyModels: 'One key for 100+ models from all providers.',
  describeChange: 'Describe a change…',
  describeCreateOrChange: 'Describe what you want to create or change.',
  chatPrototypeTitle: 'Prototype chat',
  chatRuntimeAgentServer: 'Agent Server',
  chatRuntimeFetch: 'Local fetch',
  agentServerUrl: 'Agent Server URL',
  agentServerUrlPlaceholder: 'http://127.0.0.1:7600',
  agentServerProbe: 'Check Agent Server',
  agentServerOnline: 'Agent Server online',
  agentServerOffline: 'Agent Server offline — using local fetch',
  stopGenerating: 'Stop generating',
  editMessage: 'Edit message',
  cancelEdit: 'Cancel',
  resendMessage: 'Send again',
  sendMessage: 'Send message',
  toolFinished: 'Done',
  toolRunning: 'Running…',
  toolError: 'Error',
  toolSteps: params('Earlier steps: {count}'),
  toolStepsFailed: params('failed: {count}'),
  unknownTool: 'Unknown tool',
  permissionRequestTitle: 'Permission request',
  permissionRequest: params('{tool} is requesting permission.'),
  baseURLPlaceholder: 'Base URL (e.g. http://localhost:11434/v1)',
  modelIDPlaceholder: 'Model ID (e.g. llama-3.3-70b)',
  aiProvider: 'AI Provider',
  providerSettings: 'Provider settings',
  openProviderSettings: 'Open provider settings',
  settings: 'Settings',
  settingsDescription: 'Manage integrations and app preferences.',
  settingsGeneral: 'General',
  settingsMenus: 'Menus',
  settingsMenusDescription:
    'Choose a layer type and reorder its context menu. Each type has its own default order; Reset restores that default.',
  settingsMenusNodeType: 'Layer type',
  settingsMenusReset: 'Reset this type',
  settingsMenusResetAll: 'Reset all types',
  settingsMenusMoveUp: 'Move up',
  settingsMenusMoveDown: 'Move down',
  settingsMenusUsingDefault: 'Using the default order for this type.',
  settingsMenuNodeDefault: 'Default',
  settingsMenuNodeGroup: 'Group',
  settingsMenuNodeVector: 'Vector',
  settingsMenuNodeBoolean: 'Boolean',
  settingsMenuNodeComponent: 'Component',
  settingsMenuNodeComponentSet: 'Component set',
  settingsMenuNodeInstance: 'Instance',
  settingsTailwind: 'Tailwind',
  settingsTailwindDescription:
    'Classic Tailwind configs used when generating Tailwind JSX. Earlier entries win; built-in defaults are last.',
  tailwindConfigEmpty: 'No project Tailwind configs yet. Add one to map design values to your tokens.',
  tailwindConfigName: 'Config name',
  tailwindConfigJson: 'Tailwind config JSON',
  tailwindConfigAdd: 'Add config',
  tailwindConfigRemove: 'Remove config',
  tailwindConfigMoveUp: 'Move up (higher priority)',
  tailwindConfigMoveDown: 'Move down (lower priority)',
  tailwindConfigSave: 'Save',
  tailwindConfigSaving: 'Saving…',
  tailwindConfigSaved: 'Saved to this browser.',
  tailwindConfigInvalid: 'Fix invalid JSON before saving.',
  tailwindConfigSaveFailed: 'Could not save Tailwind configs.',
  settingsLanguage: 'Language',
  settingsLanguageDescription: 'Choose the language used by the app interface.',
  settingsTypography: 'Typography',
  settingsDefaultFont: 'Default font',
  settingsDefaultFontDescription:
    'Applied to new text layers. Matching fonts are omitted from Tailwind and Design JSX output.',
  settingsEditing: 'Editing',
  settingsSnappingDescription:
    'Control alignment while editing paths, moving, and resizing layers.',
  snapToGeometry: 'Snap to geometry',
  snapToGeometryDescription: 'Align dragged vector points to other points in the path.',
  snapToObjects: 'Snap to objects',
  snapToObjectsDescription:
    'Align vector points and layer bounds to nearby layer edges and centers.',
  snapToPixelGrid: 'Snap to pixel grid',
  snapToPixelGridDescription:
    'Align vector points, moved layers, and resized edges to whole pixels.',
  snapTemporaryDisableHint: 'Hold Control while dragging to temporarily disable snapping.',
  settingsAIAndAgents: 'AI & agents',
  settingsSkills: 'Skills',
  settingsSkillsHelp:
    'Skills for this chat. All personal skills are selected by default; uncheck groups or skills to exclude them. Your choice is saved on this device.',
  settingsSkillsAllSelected: 'All personal skills are selected.',
  settingsSkillsEmpty: 'No personal skill groups yet. Create skills on the Skills page first.',
  settingsSkillsManageHint: 'Author and fetch skills on the',
  settingsUsage: 'Usage',
  usageDescription: 'Local usage summaries from recorded AI requests.',
  usageRequests: 'Requests',
  usageCompleted: 'Completed',
  usageInputTokens: 'Input tokens',
  usageOutputTokens: 'Output tokens',
  usageByModel: 'By model',
  usageNoData: 'No usage data recorded.',
  usageNotReported: 'Not reported',
  usageCacheNote: 'Cache values are shown only when the provider reports them.',
  settingsDiagnostics: 'Diagnostics',
  diagnosticsTitle: 'Diagnostics',
  diagnosticsModelStepCompleted: 'AI model step completed',
  diagnosticsChatCompleted: 'AI chat completed',
  diagnosticsChatFailed: 'AI chat failed',
  diagnosticsStorageFailed: 'Storage operation failed',
  diagnosticsDocumentFailed: 'Document operation failed',
  diagnosticsACPFailed: 'ACP transport failed',
  diagnosticsMCPFailed: 'MCP connection failed',
  diagnosticsTechnicalEvent: 'Technical event',
  diagnosticsRetention: 'Diagnostics retention',
  diagnosticsRetentionDescription: 'Keep up to this many recent events locally.',
  diagnosticsDescription:
    'Store technical events locally to help troubleshoot OpenPencil. Prompts, design content, credentials, and API keys are excluded.',
  localDiagnostics: 'Local diagnostics',
  localDiagnosticsDescription: 'Keep recent technical events on this device.',
  usageHistory: 'Usage history',
  usageHistoryDescription: 'Keep local AI usage summaries.',
  diagnosticsEventCount: params('{count} events · {size} KB'),
  diagnosticsCopy: 'Copy diagnostics',
  diagnosticsClear: 'Clear',
  diagnosticsClearDescription: 'This removes locally stored diagnostic events from this device.',
  diagnosticsCleared: 'Diagnostics cleared.',
  diagnosticsCopied: 'Diagnostics copied to clipboard.',
  diagnosticsCopyFailed: 'Could not copy diagnostics to the clipboard.',
  models: 'Models',
  modelsDescription:
    'Configure multiple models with high / medium / low tiers. Chat can use Auto (agent picks by task) or a specific model. Disable models you do not want used.',
  modelsListTitle: 'Models',
  modelsListHint: 'Enable models the agent may use. Tier guides Auto selection.',
  modelAdd: 'Add model',
  modelNewName: 'New model',
  modelRemove: 'Remove model',
  modelEnabled: 'Enabled',
  modelDisabled: 'off',
  modelDisplayName: 'Display name',
  modelTier: 'Tier',
  modelTierHigh: 'High',
  modelTierMedium: 'Medium',
  modelTierLow: 'Low',
  modelDefaultSelection: 'Default chat selection',
  modelAuto: 'Auto',
  modelAutoHint: 'Agent picks an enabled model by task tier',
  modelPickerLabel: 'Chat model',
  modelNoneEnabled: 'Enable at least one model in Settings → AI.',
  mcpConnections: 'MCP connections',
  mcpConnectionsDescription: 'Give ACP agents access to trusted remote tools and services.',
  addConnection: 'Add connection',
  addMCPConnection: 'Add MCP connection',
  editMCPConnection: 'Edit MCP connection',
  mcpConnectionEditorDescription: 'Configure a Streamable HTTP server and optional authentication.',
  connectionName: 'Connection name',
  mcpServerURL: 'MCP server URL',
  enableMCPConnection: 'Enable for ACP agents',
  mcpBearerAuthentication: 'Use bearer authentication',
  mcpBearerToken: 'Bearer token',
  mcpBearerTokenPlaceholder: 'Enter bearer token',
  mcpBearerTokenRequired: 'Enter a bearer token before enabling this connection.',
  deleteMCPConnection: 'Delete connection',
  deleteMCPConnectionDescription: 'Delete this MCP connection and remove its saved bearer token?',
  noMCPConnections: 'No external MCP connections configured.',
  addModel: 'Add model',
  editModel: 'Edit model',
  modelEditorDescription: 'Provider, model, credentials, and capabilities.',
  modelName: 'Name',
  modelConfiguration: 'Model',
  connectionSettings: 'Connection',
  modelCapabilities: 'Capabilities',
  modelCapabilitiesDetected: 'Detected from the selected model.',
  modelCapabilitiesManual: 'Declare compatibility for this custom model.',
  modelCapabilityTools: 'Tool calling',
  modelCapabilityVision: 'Image input',
  modelCapabilityToolsShort: 'Tools',
  modelCapabilityVisionShort: 'Vision',
  selectDesignModel: 'Select design model',
  modelNeedsCredential: 'Needs key',
  modelAgentConnection: 'Agent',
  harnessThinkingLevel: 'Thinking level',
  harnessThinkingOff: 'Off',
  harnessThinkingMinimal: 'Minimal',
  harnessThinkingLow: 'Low',
  harnessThinkingMedium: 'Medium',
  harnessThinkingHigh: 'High',
  harnessThinkingExtraHigh: 'Extra high',
  harnessToolPermissions: 'Tool permissions',
  harnessPermissionReads: 'Ask before edits and commands',
  harnessPermissionEdits: 'Ask before commands',
  harnessPermissionAll: 'Allow all tools',
  saveModel: 'Save model',
  deleteModel: 'Delete model',
  deleteModelDescription: 'Delete this model and remove its role assignments?',
  modelAssignments: 'Assignments',
  modelAssignmentsDescription: 'Choose which configured model handles each type of work.',
  modelRoleDesign: 'Design agent',
  modelRoleReview: 'Review',
  modelRoleFast: 'Fast tasks',
  modelRoleVision: 'Vision',
  modelRoleDesignDescription: 'AI chat and canvas edits',
  modelRoleReviewDescription: 'Explicit plan and design reviews',
  modelRoleFastDescription: 'Low-cost background work',
  modelRoleVisionDescription: 'Screenshots and image references',
  modelRoleUseDesign: 'Same as Design',
  noModel: 'None',
  back: 'Back',
  settingsMedia: 'Media',
  settingsMCP: 'MCP & automation',
  mcpDescription: 'Monitor and restart the local MCP server used by agents and automation.',
  mcpStatus: 'Status',
  mcpPort: 'Port',
  mcpAddress: 'Address',
  mcpVersion: 'Version',
  mcpAuthentication: 'Require authentication',
  mcpAuthenticationDescription:
    'Protect the localhost MCP endpoint with a bearer token. Disable only on a trusted machine.',
  mcpAuthenticationToken: 'Bearer token',
  mcpAuthenticationTokenDescription:
    'Generate a token here, copy it when it appears, then dismiss it — it cannot be shown again. Regenerate to issue a new token and reconnect clients.',
  mcpAuthenticationTokenMissing:
    'No token yet. Generate one to require authentication on the local server.',
  mcpAuthenticationTokenConfigured: 'A bearer token is configured',
  mcpAuthenticationTokenRevealHint:
    'Copy this token now. After you dismiss it, you can only regenerate a new one.',
  mcpGenerateAuthenticationToken: 'Generate token',
  mcpRegenerateAuthenticationToken: 'Regenerate token',
  mcpDismissAuthenticationToken: 'Done',
  mcpRootDirectory: 'MCP root directory',
  mcpRootDirectoryDefault: 'User home directory (default)',
  mcpChooseRootDirectory: 'Choose folder',
  mcpUseDefaultRoot: 'Use default',
  mcpRootDirectoryDescription:
    'File tools are limited to this folder. Restart the MCP server to apply changes.',
  mcpTools: 'Available tools',
  mcpToolsEnabled: params('{enabled} of {total} enabled'),
  mcpEnableAllTools: 'Enable all',
  mcpSearchTools: 'Search MCP tools',
  mcpReadOnlyTools: 'Read-only tools',
  mcpSideEffectTools: 'Tools with side effects',
  mcpToolsRestartNotice:
    'Restart the MCP server, then reconnect stdio clients, to apply tool availability changes.',
  mcpExternalRestartNotice:
    'This server is managed by another process. Restart that process to apply changes.',
  mcpRestart: 'Restart MCP server',
  mcpExternallyManaged: 'Managed externally',
  mcpStarting: 'Starting…',
  mcpStatus_idle: 'Not initialized',
  mcpStatus_starting: 'Starting',
  mcpStatus_running: 'Running',
  mcpStatus_stopped: 'Stopped',
  mcpStatus_error: 'Error',
  vectorization: 'Image vectorization',
  vectorizationDescription:
    'Send image layers to Recraft or fal.ai and return editable vectors. Provider charges may apply.',
  vectorizeProvider: 'Vectorization service',
  settingsStorage: 'Cloud storage',
  storageWorkspace: 'Storage workspace',
  openStorageWorkspace: 'Open workspace',
  newStoredDocument: 'New document',
  emptyStorageWorkspace: 'No stored documents yet.',
  loadingDocuments: 'Parsing documents…',
  storageNotConfigured: 'Configure storage before using this workspace.',
  recentFiles: 'Recent files',
  recentFilesDescription: 'Continue working on a design or start a new one.',
  noRecentFiles: 'No recent files yet',
  noRecentFilesDescription: 'Files you open in the desktop app will appear here.',
  searchFiles: 'Search files…',
  searchRecentAndStorageFiles: 'Search recent and storage files…',
  newDesign: 'New design',
  noMatchingFiles: params('No files match “{query}”.'),
  storageProviderS3: 'S3 storage',
  storageProviderR2: 'Cloudflare R2',
  storageProviderAmazonS3: 'Amazon S3',
  storageProviderBackblaze: 'Backblaze B2',
  loadingStorageWorkspace: 'Loading storage workspace…',
  copyStorageCors: 'Copy CORS JSON',
  storageEndpoint: 'Endpoint',
  storageBucket: 'Bucket',
  storageRegion: 'Region',
  storageAccessKeyID: 'Access key ID',
  storageSecretAccessKey: 'Secret access key',
  save: 'Save',
  credentialStorage: params('Credentials: {backend}'),
  credentialBackendNative: 'system credential store',
  credentialBackendBrowser: 'encrypted browser storage',
  credentialBackendMemory: 'this session only',
  rememberCredentials: 'Remember credentials on this browser',
  done: 'Done',
  mobilePanelNavigation: 'Mobile panel navigation',
  toolOptions: params('{tool} options'),
  removeGradientStop: 'Remove gradient stop',
  notifications: 'Notifications',
  saveAsPrompt: 'Save as:',
  openFileFailed: params('Could not open “{name}”: {error}'),
  saveFileFailed: params('Could not save “{name}”: {error}'),
  saveFileSaved: params('Saved “{name}”'),
  savingDocument: 'Saving document…',
  savingThumbnail: 'Updating thumbnail…',
  autosavingDocument: 'Autosaving…',
  savingLocalDraft: 'Saving local draft…',
  documentBusyLeaveTitle: 'Work is still in progress',
  documentBusyLeavePrompt: 'Leave this page anyway? Unfinished saves may be lost.',
  browserFileAPINotSupported:
    "Your browser doesn't support the local file API. Files will be downloaded instead of saved in place.",
  useChrome: 'Use Chrome',
  orEdgeForFullSupport: 'or Edge for full support.',
  dismiss: 'Dismiss',
  apiKey: 'API Key',
  apiType: 'API Type',
  baseURL: 'Base URL',
  modelID: 'Model ID',
  customModelID: 'Custom model ID',
  customModel: 'Custom model…',
  advancedModelSettings: 'Advanced settings',
  outputLimit: 'Output limit',
  outputLimitAutomatic: 'Automatic recommendation',
  reasoningEffort: 'Reasoning effort',
  reasoningEffortPlaceholder: 'e.g. low, high, none',
  reasoningEffortDescription: 'Optional provider-specific value.',
  supported: 'Supported',
  unsupported: 'Not supported',
  tokens: 'tokens',
  chatInsufficientCredit:
    'The provider account has insufficient credit or quota. Top it up and try again.',
  chatOutputLimit:
    'The model ran out of output tokens while reasoning. Raise Max output tokens or lower reasoning effort.',
  chatRequestFailed: 'The model request failed. Check the provider settings and try again.',
  chatVisionUnsupported:
    'This model does not accept images. Use a vision-capable model, or for DeepSeek use deepseek-v4-flash-vision-exp.',
  maxOutputTokens: 'Max output tokens',
  clear: 'Clear',
  keySavedReplace: 'Key saved — enter new to replace',
  getAPIKeyGeneric: 'Get API key →',
  pexelsAPIKey: 'Pexels API Key (stock photos)',
  unsplashAccessKey: 'Unsplash Access Key',
  stockPhotoToolOptional: 'Optional — for stock_photo tool',
  pexelsAlternativeOptional: 'Optional — alternative to Pexels',
  getPexelsAPIKey: 'Get free Pexels API key →',
  getUnsplashAccessKey: 'Get free Unsplash access key →',
  completions: 'Completions',
  responses: 'Responses',
  yourName: 'Your name',
  enterYourName: 'Enter your name',
  shareThisFile: 'Share this file',
  joinRoom: 'Join room',
  join: 'Join',
  roomLink: 'Room link',
  joinCollaboration: 'Join collaboration',
  joinSharedFile: 'Someone shared this file with you. Enter your name to join.',
  orJoinRoom: 'or join a room',
  pasteRoomLinkOrId: 'Paste room link or ID',
  connected: 'Connected',
  search: 'Search…',
  noResults: 'No results',
  share: 'Share',
  appUpToDate: 'OpenPencil is up to date',
  updateAvailableTitle: 'Update OpenPencil',
  updateAvailable: params('OpenPencil {version} is available.'),
  updateInstallPrompt:
    'Download and install it now? The app will restart after the update is installed.',
  downloadingUpdate: params('Downloading OpenPencil {version}'),
  updateInstalledTitle: 'Update installed',
  updateInstalled: params('OpenPencil {version} was installed{size}. Restarting now.'),
  updateUnavailable:
    'Updates are not available yet. Publish a signed release with latest.json first.',
  updateCheckFailed: params('Could not check for updates: {error}'),
  versionHistory: 'Version history',
  versionHistoryShortcutHint: params('Press {shortcut} to add to version history while editing.'),
  currentVersion: 'Current version',
  autosaveVersions: params('{count} autosave versions'),
  showOlder: 'Show older',
  saveVersion: 'Save version',
  saveVersionDescription: 'Add a named checkpoint to this file’s history.',
  versionTitle: 'Title',
  versionDescription: 'Description (optional)',
  restoreVersion: 'Restore this version',
  versionHistoryNeedsCloud: 'Version history is available for saved cloud files.',
  versionHistoryLoadFailed: 'Could not load version history.',
  versionSaveFailed: 'Could not save this version.',
  versionRestoreFailed: 'Could not restore this version.',
  viewingVersion: params('Viewing version from {date}'),
  loadingVersions: 'Loading versions…',
  comments: 'Comments',
  commentFilter: 'Comment filter',
  openComments: 'Open',
  resolvedComments: 'Resolved',
  commentsThisPage: 'This page',
  commentsToday: 'Today',
  commentsYesterday: 'Yesterday',
  commentsOlder: 'Older',
  commentCanvasHint: 'Click the canvas to leave a comment.',
  commentPlaceholder: 'Write a comment',
  replyPlaceholder: 'Reply',
  postComment: 'Post',
  reply: 'Reply',
  resolveComment: 'Resolve',
  reopenComment: 'Reopen',
  deleteComment: 'Delete comment',
  backToComments: 'All comments',
  noComments: 'No comments yet.',
  loadingComments: 'Loading comments…',
  commentsNeedCloud: 'Comments are available for saved cloud files.',
  commentsLoadFailed: 'Could not load comments.',
  commentSaveFailed: 'Could not save this comment.',
  commentUpdateFailed: 'Could not update this comment.',
  commentDeleteFailed: 'Could not delete this comment.',

  aiReviews: 'AI reviews',
  aiReviewNew: 'New review',
  backToAiReviews: 'All reviews',
  noAiReviews: 'No AI reviews yet.',
  loadingAiReviews: 'Loading reviews…',
  aiReviewsNeedCloud: 'AI reviews are available for saved cloud files.',
  aiReviewsLoadFailed: 'Could not load AI reviews.',
  aiReviewSaveFailed: 'Could not save this AI review.',
  aiReviewDelete: 'Delete review',
  aiReviewDeleteFailed: 'Could not delete this AI review.',
  aiReviewRunFailed: 'AI review failed.',
  aiReviewTitle: 'Title',
  aiReviewBody: 'Requirement',
  aiReviewBodyHint: 'Paste the requirement text to review against (optional).',
  aiReviewAddSelection: 'Add selection as markers',
  aiReviewMarkerCount: params('{count} markers'),
  aiReviewScopePage: 'Current page',
  aiReviewScopePageHint: 'No markers — AI will review the current page. Optionally add a selection.',
  aiReviewSkills: 'Skills',
  aiReviewSkillsEmpty: 'No personal skill groups yet. Create skills on the Skills page.',
  aiReviewRunAi: 'Run AI review',
  aiReviewRunning: 'Running AI…',
  aiReviewAnalysis: 'Analysis',
  aiReviewSubmit: 'Submit review',
  aiReviewSaving: 'Saving snapshot…',
  aiReviewLinkedVersion: params('Linked version: {title}'),
  aiReviewSeverityError: 'Error',
  aiReviewSeverityWarning: 'Warning',
  aiReviewSeverityInfo: 'Info',
  aiReviewNoComments: 'No comments yet',
  aiReviewMarkerIndex: params('#{index}')
} as const

export const dialogMessages = i18n('dialogs', dialogMessageDefaults)
